import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { IconName, IconSizes, PearlIcon } from 'dbi-pearl-ui-kit';
import { ApiLoaderStyled, PearlConnectApiOverlayStyled } from './ApiLoader.styled';
import logo from '../../../assets/logos/Pearl_Launch_Logo_Black_On_Clear_Tinyfied.png';
import { useTranslation } from 'react-i18next';
import { newPageTrigger } from 'LivePerson';
import { isPearlVendorSignupFlowPath } from 'shared/utils/pearlVendorSignupFlow';
import { PearlConnectSpinnerRing } from '../PearlConnectFlowLoader/PearlConnectSpinnerRing.styled';

const ApiLoader = () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const pearlSignup = isPearlVendorSignupFlowPath(pathname);

    useEffect(() => {
        newPageTrigger(window.location.href);
    }, [window.location.href]);

    if (pearlSignup) {
        return (
            <PearlConnectApiOverlayStyled role="alertdialog" aria-busy="false" id="api-loader">
                <PearlConnectSpinnerRing role="status" aria-live="polite" aria-label="Loading" />
            </PearlConnectApiOverlayStyled>
        );
    }

    return (
        <ApiLoaderStyled role="alertdialog" aria-busy="false" id="api-loader">
            <div className="loader">
                <img className={'logo'} src={logo} alt={t('ApiLoaderLogo')} />
                <div className={'icons'}>
                    <div className="icon">
                        <PearlIcon iconName={IconName.DIAMOND_FILLED} size={IconSizes.MD} />
                    </div>
                    <div className="icon">
                        <PearlIcon iconName={IconName.DIAMOND_FILLED} size={IconSizes.MD} />
                    </div>
                    <div className="icon">
                        <PearlIcon iconName={IconName.DIAMOND_FILLED} size={IconSizes.MD} />
                    </div>
                    <div className="icon">
                        <PearlIcon iconName={IconName.DIAMOND_FILLED} size={IconSizes.MD} />
                    </div>
                    <div className="icon">
                        <PearlIcon iconName={IconName.DIAMOND_FILLED} size={IconSizes.MD} />
                    </div>
                </div>
            </div>
        </ApiLoaderStyled>
    );
};

export { ApiLoader };
